import React from "react";
import { Layout, Row, Col } from "antd";
import SiteHeader from "./Header";
import SiteSidebar from "./Sidebar";

const { Content } = Layout;

const MainLayout = ({ active, children }) => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SiteHeader />
      <Layout style={{ height: "calc(100vh - 64px)" }}>
        <SiteSidebar active={active} />
        <Layout style={{ padding: "24px", marginLeft: 250, overflow: "auto", background: "#fafafa" }}>
          <Row justify="center">
            <Col xs={24}>
              <Content style={{  borderRadius: "8px" }}>
                {children}
              </Content>
            </Col>
          </Row>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
